'use client'

import {VideoReview} from '../type'
import {useState} from 'react'

import icon from '@/src/shared/assets/media/icon-play-youtube.png'
import noPhotoPic from '@/src/shared/assets/media/no-photo.png'
import {Image} from '@/src/shared/ui/image'
import {sanitizeHtml} from '@/src/shared/utils/functions'

import * as UI from './tile.styled'

interface IProps {
  review: VideoReview
}

export const VideoReviewTile = ({review}: IProps) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <UI.Wrapper onClick={() => setShowModal(open => !open)}>
      <Image
        alt={review.title}
        width={291}
        height={218}
        src={`${review.thumbnail?.src}` || noPhotoPic}
      />
      <UI.Icon src={icon} alt="" width={30} height={21} />
      <UI.Title>{review.title}</UI.Title>
      <UI.Modal open={showModal} width={1000} key={String(showModal)}>
        <div dangerouslySetInnerHTML={{__html: sanitizeHtml(review.iframe)}} />
      </UI.Modal>
    </UI.Wrapper>
  )
}
